module.exports = __webpack_public_path__ + "img/next.2719ac01.svg";